export default "__VITE_ASSET__wdOwTa0c__"